import { buildCollection, buildProperty } from "@firecms/core";
import { HomeButton } from "../components/HomeButton";

export type Purchase = {
    user_id: number;
    type: string;
    item: string;
    stars_paid: number;
    promo_code_used?: string;
    discount_applied?: number;
    telegram_charge_id?: string;
    provider_charge_id?: string;
    created_at: Date;
};

export const purchasesCollection = buildCollection<Purchase>({
    id: "purchases",
    name: "Purchases",
    singularName: "Purchase",
    path: "purchases",
    icon: "Receipt",
    group: "Revenue",
    Actions: HomeButton,
    description: "Transaction history for subscriptions and booster packs",
    permissions: {
        edit: false,
        create: false,
        delete: false,
    },
    properties: {
        user_id: buildProperty({
            name: "User ID",
            dataType: "number",
            readOnly: true,
        }),
        type: buildProperty({
            name: "Type",
            dataType: "string",
            enumValues: {
                subscription: "📅 Subscription",
                booster: "🚀 Booster Pack",
            },
            readOnly: true,
        }),
        item: buildProperty({
            name: "Item",
            dataType: "string",
            enumValues: {
                pro: "Pro Monthly",

                starter: "Starter",
                study_session: "Study Session",
                power_pack: "Power Pack",
                weekly_pass: "Weekly Pass",
            },
            readOnly: true,
        }),
        stars_paid: buildProperty({
            name: "Stars Paid",
            dataType: "number",
            readOnly: true,
        }),
        promo_code_used: buildProperty({
            name: "Promo Code Used",
            dataType: "string",
            readOnly: true,
        }),
        discount_applied: buildProperty({
            name: "Discount Applied",
            dataType: "number",
            description: "Discount in stars",
            readOnly: true,
        }),
        telegram_charge_id: buildProperty({
            name: "Telegram Charge ID",
            dataType: "string",
            readOnly: true,
        }),
        provider_charge_id: buildProperty({
            name: "Provider Charge ID",
            dataType: "string",
            readOnly: true,
        }),
        created_at: buildProperty({
            name: "Date",
            dataType: "date",
            mode: "date_time",
            readOnly: true,
        }),
    },
    propertiesOrder: ["user_id", "type", "item", "stars_paid", "promo_code_used", "created_at"],
});
